exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".biometry-required-page {\n  min-height: calc(100vh - 80px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 24px;\n}\n\n.biometry-required-form {\n  width: 100%;\n  max-width: 420px;\n  padding: 24px;\n  border: 1px solid #d9dee5;\n  background: #fff;\n}\n\n.biometry-required-form h2 {\n  margin: 0 0 18px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.biometry-required-form label {\n  display: block;\n  margin-bottom: 14px;\n}\n\n.biometry-required-form span {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n\n.biometry-required-form input {\n  width: 100%;\n  height: 34px;\n  padding: 6px 8px;\n  border: 1px solid #c7ccd3;\n}\n\n.biometry-required-error {\n  margin-bottom: 12px;\n  color: #b00020;\n}\n\n.biometry-required-form button {\n  width: 100%;\n  height: 36px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/views/biometry-required/biometry-required.component.css
// module id = ../../../../../src/app/content-page/views/biometry-required/biometry-required.component.css
// module chunks = main